import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialog, PageEvent } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { DescargarLotesComponent } from '../descargar-lotes/descargar-lotes.component';

@Component({
  selector: 'app-cruce-sgo',
  templateUrl: './cruce-sgo.component.html',
  styleUrls: ['./cruce-sgo.component.scss']
})
export class CruceSgoComponent implements OnInit {

  displayedColumns: string[] = ['ORDEN', 'SGO', 'KAFKA', 'TECH', 'FECHA_SGO', 'FECHA_KAFKA', 'FECHA_TECH'];
  dataSource = new MatTableDataSource<any>([]);
  resultsLength = 0;
  pageSize = 10;
  actpage = 0;
  FILTER = '';

  grupoVal = new FormGroup({
    FILTRO: new FormControl(''),
    FECHA_INI: new FormControl(new Date()),
    FECHA_FIN: new FormControl(new Date())
  });

  @ViewChild('paginatortable') paginatortable: MatPaginator;

  constructor(
    private gateway: GatewayService,
    private localSave: LocalSaveService,
    private spinner: NgxSpinnerService,
    public pageTitle: ComponentPageTitle,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.pageTitle.title = 'Cruce SGO';
    this.get(0);
  }

  get(page) {
    this.spinner.show();
    const params = {
      NUM_ELEMENTOS: this.pageSize,
      NUM_PAGINA: page,
      FECHA_INI: this.grupoVal.controls.FECHA_INI.value,
      FECHA_FIN: this.grupoVal.controls.FECHA_FIN.value,
      FILTRO: this.grupoVal.controls.FILTRO.value
    };

    this.gateway.get('getCruceSGO', params).then((result: any) => {
      this.dataSource = new MatTableDataSource(result.rows || []);
      this.resultsLength = result.total || 0;
      this.spinner.hide();
    }).catch((err) => {
      this.spinner.hide();
    });
  }

  filtrogeneral() {
    this.actpage = 0;
    if (this.paginatortable) {
      this.paginatortable.pageIndex = 0;
    }
    this.get(0);
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  descargar() {
    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      width: '500px',
      disableClose: true,
      data: {
        params: {
          FECHA_INI: this.grupoVal.controls.FECHA_INI.value,
          FECHA_FIN: this.grupoVal.controls.FECHA_FIN.value,
          FILTRO: this.grupoVal.controls.FILTRO.value
        },
        nombreServicioCantRegistros: 'getContCruceSGO',
        nombreServicioRegistros: 'descargarCruceSGO',
        nombreArchivo: 'Cruce_SGO.xlsx',
        columnas: [
          { header: 'ORDEN', key: 'ORDEN' },
          { header: 'SGO', key: 'SGO' },
          { header: 'KAFKA', key: 'KAFKA' },
          { header: '+TECH', key: 'TECH' },
          { header: 'FECHA SGO', key: 'FECHA_SGO' },
          { header: 'FECHA KAFKA', key: 'FECHA_KAFKA' },
          { header: 'FECHA +TECH', key: 'FECHA_TECH' }
        ]
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp && resp.valid) {
        // descarga completada
      }
    });
  }

  formatDate(date: any): string {
    if (!date || date === '--') return '--';
    return date;
  }
}
